import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ProfileBioSection = ({ user, onEdit }) => {
  const intl = useIntl();

  return (
    <div className="bg-succession-bg-secondary rounded-lg border border-succession-border p-6">
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-xl font-semibold text-succession-text-primary">{intl.formatMessage({ id: 'succession.profile_edit.sections.profile_bio.title' })}</h3>
        <button
          onClick={onEdit}
          className="inline-flex items-center px-3 py-1.5 border border-succession-border rounded-lg text-sm text-succession-text-primary hover:bg-succession-bg-primary transition-colors"
        >
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          {intl.formatMessage({ id: 'succession.profile_edit.common.edit' })}
        </button>
      </div>
      {user.bio ? (
        <p className="text-succession-text-secondary whitespace-pre-wrap">{user.bio}</p>
      ) : (
        <p className="text-succession-text-muted italic">{intl.formatMessage({ id: 'succession.profile_edit.sections.profile_bio.no_bio' })}</p>
      )}
    </div>
  );
};

ProfileBioSection.propTypes = {
  user: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ProfileBioSection;
